const Products = [
    {
        "id": 1
        , "name": "Pizza Margherita",
        "description": "Classic Italian pizza with tomato, mozzarella, and basil.",
        "price": 12.99,
        "quantity":1,
        "image": "https://images.prismic.io/eataly-us/ed3fcec7-7994-426d-a5e4-a24be5a95afd_pizza-recipe-main.jpg?auto=compress,format"
    },
    {
        "id": 2
        , "name": "Chicken Tikka Masala extra chease",
        "description": "Tender chicken pieces in a creamy tomato sauce with Indian spices.",
        "price": 15.99,
        "quantity":1,
        "image": "https://www.cookwithkushi.com/wp-content/uploads/2022/09/authentic_chicken_tikka_masala_03.jpg"
    },
    {
        "id": 3
        , "name": "Sushi Combo",
        "description": "Assorted sushi rolls with soy sauce and wasabi.",
        "price": 18.49,
        "quantity":1,
        "image": "https://thumbs.dreamstime.com/b/sashimi-sushi-combo-9-17392691.jpg"
    }
    ,

    {
        "id": 4
        , "name": "Food Item 1",
        "description": "Description of Food Item 1.",
        "price": 10.99,
        "quantity":1,
        "image": "https://www.sushiya.in/cdn/shop/files/chilli_garlic_tofu_1691132530.jpg?v=1691398496&width=493"
    },
    {
        "id": 5
        , "name": "Food Item 2",
        "description": "Description of Food Item 2.",
        "price": 12.49,
        "quantity":1,
        "image": "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSsQM5r1joK7dfBplbfArg-MmTggW7qabK0r4BI8msZtw&s"
    },
    {
        "id": 6
        , "name": "Chicken biryani",
        "description": "Description of Food Item 3.",
        "price": 8.99,
        "quantity":1,
        "image": "https://img.theweek.in/content/dam/week/webworld/feature/lifestyle/2017/december/chicken-biriyani.jpg"
    },
    {
        "id": 7
        , "name": "Fresh Tomato Pizza",
        "description": "Description of Food Item 4.",
        "price": 15.99,
        "quantity":1,
        "image": "https://hips.hearstapps.com/wdy.h-cdn.co/assets/cm/15/09/54ef8b64366c1_-_fresh-tomato-pizza-kqgv52-xl.jpg?crop=1xw:1.0xh;center,top&resize=980:*"
    },
    {
        "id": 8
        , "name": "Pepper and Onion Pizza",
        "description": "Description of Food Item 5.",
        "price": 9.99,
        "quantity":1,
        "image": "https://hips.hearstapps.com/hmg-prod/images/pepper-and-onion-pizza-64d13b5a8bdbd.jpg?crop=0.877xw:1.585xh;0.0945xw,0.307xh&resize=980:*"
    },

    {
        "id": 9
        , "name": "Chicken Biryani",
        "description": "Aromatic rice dish with tender chicken pieces and spices.",
        "price": 12.99,
        "quantity":1,
        "image": "https://www.licious.in/blog/wp-content/uploads/2020/12/Hyderabadi-chicken-Biryani.jpg"
    },
    {
        "id": 10
        , "name": "Margherita Pizza",
        "description": "Classic pizza with tomato, mozzarella, and basil.",
        "price": 9.99,
        "quantity":1,
        "image": "https://www.archanaskitchen.com//images/archanaskitchen/1-Author/Sandhya_Hariharan/Pizza_Margherita.jpg"
    },
    {
        "id": 11
        , "name": "Vegetable Spring Rolls",
        "description": "Crispy rolls filled with mixed vegetables.",
        "price": 5.99,
        "quantity":1,
        "image": "https://www.thecookingcollective.com.au/wp-content/uploads/2022/08/Vegetable-Spring-Rolls-2-1.jpg"
    },
    {
        "id": 12
        , "name": "Chocolate Brownie Sundae",
        "description": "Warm chocolate brownie topped with vanilla ice cream.",
        "price": 7.99,
        "quantity":1,
        "image": "https://food.fnr.sndimg.com/content/dam/images/food/fullset/2021/12/15/0/FNM_010122-Dark-Chocolate-Brownie-Sundae_s4x3.jpg.rend.hgtvcom.616.462.suffix/1639586951781.jpeg"
    }
]

export default Products;

